<template>
  <el-dialog :append-to-body="true" :title="title" :visible.sync="dialogVisible" :width="dialogWidth"
    :close-on-click-modal="false" :close-on-press-escape="false">
    <slot name="content">

    </slot>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hideDialog()">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
  export default{
    props:{
      title:{
        type:String,
        default:''
      },
      dialogWidth:{
        type:String,
        default:'60%'
      }
    },
    data(){
      return {
        dialogVisible:false
      }
    },
    methods:{
      showDialog(){
        this.dialogVisible=true
      },
      hideDialog(){
        this.dialogVisible=false
      }

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/basic/FwBaseDialog.vue